import { useEffect, useRef } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';
import { useMapStore } from '@/stores/mapStore';
import { createCasetaIcon, createGasolineraIcon } from '@/utils/markerIcons';
import type { PointGeometry } from '@/types/map';

export default function POIMarkers() {
  const map = useMap();
  const poiMarkers = useMapStore((s) => s.poiMarkers);
  const layerRef = useRef<L.LayerGroup>(L.layerGroup());

  useEffect(() => {
    layerRef.current.addTo(map);
    return () => {
      layerRef.current.remove();
    };
  }, [map]);

  useEffect(() => {
    layerRef.current.clearLayers();

    poiMarkers.forEach((feature) => {
      const geom = feature.geometry as PointGeometry;
      const [lon, lat] = geom.coordinates;
      const props = feature.properties;
      const poiType = props.type || '';

      const icon =
        poiType === 'caseta' ? createCasetaIcon() : createGasolineraIcon();

      const name = props.name || 'POI';
      const section = props.section || '';
      const operator = props.operator || '';

      let tooltip = `<strong>${name}</strong>`;
      if (section) tooltip += `<br/>${section}`;
      if (operator) tooltip += `<br/>${operator}`;

      L.marker([lat, lon], { icon })
        .bindTooltip(tooltip)
        .addTo(layerRef.current);
    });
  }, [poiMarkers]);

  return null;
}
